import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/pages/index'
import Detail from '@/pages/detail'
import Archive from '@/pages/archive'
import Flink from '@/pages/flink'
import AboutMe from '@/pages/aboutme'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'Index',
            component: Index
        },
        {
            path: '/detail/:id',
            name: 'Detail',
            component: Detail,
            props: true
        },
        {
            path: '/archive/:id',
            name: 'Archive',
            component: Archive,
            props: true
        },
        {
            path: '/flink',
            name: 'Flink',
            component: Flink
        },
        {
            path: '/aboutme',
            name: 'AboutMe',
            component: AboutMe
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js